<template>
  <v-card>
    <v-footer
      color="#555555"
      tile
      class="font-weight-medium"
    >
      <v-col
        class="white--text text-center"
        cols="12"
      >
        <v-card-actions class="justify-center">
          © Desenvolvido pela
          <a
            :href="`${empresa.site}`"
            :rel="`${empresa.site}`"
            target="_blank"
            style="padding: 0 5px;"
          >
            <v-img
              :src="require('./../../assets/logo_quadritech_bco_png.png')"
              width="100px"
              class="mt-0"
              contain
            />
          </a>
        </v-card-actions>
        {{ new Date().getFullYear() }}
      </v-col>
    </v-footer>
  </v-card>
</template>
<script>
export default {
  props: {
    empresa: {
      type: Object,
    },
  },
  data() {
    return {
    };
  },
};
</script>
